import type { EnvironmentProviders } from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';
import { CONFIG } from '@config';

import { MONTHLY_STATEMENT_CONTENT_CONFIG } from './config.token';
import { LayoutSource } from './layout-source';
import { MonthlyStatementContentService } from './monthly-statement-content.service';

export const provideMonthlyStatementContent = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    { provide: MONTHLY_STATEMENT_CONTENT_CONFIG, useValue: CONFIG.monthlyStatementContent },
    { provide: LayoutSource, useExisting: MonthlyStatementContentService },
  ]);
